module.exports = {
    list: ["SIZE_SMALL", "SIZE_LARGE"]
};
